import React from 'react';

const PlusIcon = () => (
  <svg width="18px" height="18px" viewBox="0 0 18 18">
    <g id="Blinds.com" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Measure-and-Installation-/-Quote-/-Add-New-Quote-/-New-Quote-Added"
        transform="translate(-45.000000, -394.000000)"
        fill="#FFFFFF"
      >
        <g id="All-Quotes" transform="translate(30.000000, 379.000000)">
          <g id="Add-Quote">
            <g id="Icons/grey/A/Add" transform="translate(15.000000, 15.000000)">
              <path
                d="M10.5882353,7.41176471 L10.5882353,0 L7.41176471,0 L7.41176471,7.41176471 L0,7.41176471 L0,10.5882353 L7.41176471,10.5882353 L7.41176471,18 L10.5882353,18 L10.5882353,10.5882353 L18,10.5882353 L18,7.41176471 L10.5882353,7.41176471 Z"
                id="Combined-Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default PlusIcon;
